module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('a', {
    attrs: {
      "id": "thetop",
      "name": "thetop"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container contactUs",
    staticStyle: {
      "padding": "3%"
    }
  }, [_c('div', {
    staticClass: "head-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn text-white rounded-pill",
    staticStyle: {
      "background": "rgb(3, 28, 212)"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/login'
      }
    }
  }, [_c('p', {
    staticClass: "head-button-text button-text"
  }, [_vm._v("Apply Now")])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container text-center whitebg"
  }, [_c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("With American Credit time is on your side. When the clock is ticking, our streamlined approval process takes just minutes once your application is complete.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info rounded-pill px-4 py-2",
    staticStyle: {
      "background": "rgb(3, 28, 212)"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_c('p', {
    staticClass: "button-text"
  }, [_vm._v("APPLY NOW")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "a2 bluefont text-left"
  }, [_vm._v("\n          Questions About Small Business Loans from American Credit\n          "), _c('sup', [_vm._v("®")]), _vm._v("\n? Contact\n          Us Now\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a4 text-left",
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("\n          Get the credit you deserve from a lender\n          "), _c('br'), _vm._v("you can trust.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container bluebg pt-3 pb-2"
  }, [_c('div', {
    staticClass: "contexbox"
  }, [_c('h2', {
    staticClass: "text-white font-weight-bold"
  }, [_vm._v("Sitemap")]), _vm._v(" "), _c('ul', {
    staticClass: "sitemap-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/equipment-loan"
    }
  }, [_vm._v("Asset-Based Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/invoice-factoring"
    }
  }, [_vm._v("AR/Invoice Factoring")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/loan-calculator"
    }
  }, [_vm._v("Loan Calculator")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/roi-calculator"
    }
  }, [_vm._v("ROI Calculator")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/faq"
    }
  }, [_vm._v("FAQs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/partners"
    }
  }, [_vm._v("Partners")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/careers"
    }
  }, [_vm._v("Careers")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about-us"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/team"
    }
  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/why-american-credit"
    }
  }, [_vm._v("Why American Credit")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/invest"
    }
  }, [_vm._v("Investor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/contact-us"
    }
  }, [_vm._v("Contact Us")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("../assets/imgs/istockphoto-497981184-2048x2048.png"),
      "alt": "customer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('p', {
    staticClass: "triangle-border middle"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_c('i', [_vm._v("\"A growing family business keeps you running 24/7. I can’t spend days applying and months waiting for a loan. We need to keep things moving.\"")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/why-american-credit"
    }
  }, [_c('h5', {
    staticClass: "font-weight-bold"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("See how easy we make it.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a478b46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sitemap.vue
// module id = 1982
// module chunks = 5